module.exports = __webpack_public_path__ + "static/media/elainaS1.40ad06d0.png";